import React from "react"
import {
    componentStyles,
    IncludedAddOns,
    NumberOfGuestsInput,
    VerticalStack,
} from "@mallardbay/lib-react-components"

import { useCheckoutFlow } from "~components/pages/listing/checkout/checkout-flow/checkout-flow-provider"
import ExtraAddOns from "~components/pages/listing/checkout/add-ons/extra-add-ons"
import Divider from "~components/shared/todo-lib-react-components/divider"
import COPY from "~config/copy-constants"

export default function CheckoutFlowGuestsAndAddOnsStepContent() {
    const {
        packageState,
        updatePackageState,
        pricingPackage,
        editableFields,
        listing,
    } = useCheckoutFlow()

    const styles = useStyles()

    // For typescript. They will always be here by this point.
    if (!pricingPackage || !listing) return null

    return (
        <VerticalStack style={styles.root}>
            <NumberOfGuestsInput
                pricingPackage={pricingPackage}
                value={packageState.number_of_guests}
                onChange={(newNumberOfGuests) =>
                    updatePackageState({ number_of_guests: newNumberOfGuests })
                }
                isDisabled={!editableFields.total_guests}
                label={COPY.YOUR_PARTY_SIZE}
            />
            <Divider />
            <IncludedAddOns
                trophyAddOns={pricingPackage.trophies}
                gearRentalAddOns={pricingPackage.gear_rentals}
                mealUpgradeAddOns={pricingPackage.meal_upgrades}
                otherAddOns={pricingPackage.other_add_ons}
            />
            <ExtraAddOns listing={listing} pricingPackage={pricingPackage} />
        </VerticalStack>
    )
}

function useStyles() {
    return componentStyles({
        root: { alignItems: "stretch" },
    })
}
